
export default {
  methods: {
    closePopUp() {
      this.$emit("close");
    },
  },
};
